import { Button } from '@/app/_components/ui/button';
import { Separator } from '@/app/_components/ui/separator';
import { useSidebar } from '@/app/_components/ui/sidebar';
import { cn } from '@/app/_lib/utils';
import Link from '@/app/_adapters/next-link';
import { LogOut, Settings } from 'lucide-react';

type SidebarUserActionsProps = {
  onSignOut: () => void;
  className?: string;
};

export default function SidebarUserActions({
  onSignOut,
  className,
}: SidebarUserActionsProps) {
  const { isMobile, openMobile, setOpenMobile } = useSidebar();

  return (
    <div className={cn('space-y-1', className || '')}>
      <Link
        href="/dashboard/settings"
        onClick={() => {
          if (isMobile && openMobile) setOpenMobile(false);
        }}
      >
        <Button
          variant="ghost"
          className="w-full justify-start mb-1 hover:cursor-pointer"
        >
          <Settings />
          Settings
        </Button>
      </Link>
      <Separator />
      <Button
        variant="ghost"
        className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50 hover:cursor-pointer"
        onClick={onSignOut}
      >
        <LogOut />
        Sign Out
      </Button>
    </div>
  );
}
